import View from "../account/views/auth/RegistrationFormView";
import components from "./components.js";
components.define("js-registration-form", View);